export default "__VITE_ASSET__BxxeUPtg__"